import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgKdSharedRoutingModule } from './sg-kd-shared-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';


@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    SgKdSharedRoutingModule,
    SgBaseSharedModule
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKdSharedModule { }
